import React, { useEffect, useState } from "react";
import "./viewDetails.scss";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import LogoImage from "../../assets/logo.png";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import CustomLoader from "../CustomLoader/CustomLoader";
import { toast } from "react-toastify";
import AllServices from "../../Services/AllServices";
import { status } from "../../Constants/Constants";
import CloseIcon from "@mui/icons-material/Close";
import "./waIcon.css";
import "./okIcon.css";
import { ImageBaseURLServer } from "../../Constants/Constants";

const imageBaseURL = ImageBaseURLServer + "CustomerFIles/";

const ViewDetails = ({ refNum, onClose, onDetails, onConfirmSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [confirmTxt, setConfirmText] = useState("Confirm Check-In");

  const formatPhoneNumber = (number) => {
    if (!number) return "";
    let digitsOnly = number.replace(/\D/g, "");
    if (digitsOnly.startsWith("0")) {
      digitsOnly = "94" + digitsOnly.substring(1);
    }
    return digitsOnly;
  };
  const contactNum = formatPhoneNumber(onDetails?.ContactNumber);

  const WA = `https://wa.me/${contactNum}`;

  const handleCheckin = async () => {
    setLoading(true);
    try {
      let response = await AllServices.confirmChecking(refNum);

      if (response.data.succuss) {
        setConfirmText("Confirmed");
        toast.success(response.data.message);
        onClose();
        onConfirmSuccess();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("Component mounted");
    console.log("confirmTxt updated:", confirmTxt);
  }, [confirmTxt]);

  return (
    <div className="wrapper">
      <div className="view-details-containor">
        {loading && (
          <div className="loader-overlay">
            <CustomLoader />
          </div>
        )}

        <button
          className="close-btn"
          onClick={onClose}
          aria-label="Close Details"
        >
          <CloseIcon />
        </button>

        <div className="modal-header">
          <img src={LogoImage} className="logo" alt="Cinnamon Lakehouse Logo" />
          <h3>Reservation Details</h3>
        </div>

        <div className="middle">
          {/* Metadata Grid Info Summary */}
          <div className="meta-grid">
            <div className="meta-card">
              <span className="meta-label">Reference ID</span>
              <span className="meta-value">
                {onDetails.Booking_Reference_ID}
              </span>
            </div>
            <div className="meta-card">
              <span className="meta-label">Check-In Date</span>
              <span className="meta-value">
                {onDetails.booking[0].Arriving_DateTime
                  ? onDetails.booking[0].Arriving_DateTime.split("T")[0]
                  : "-"}
              </span>
            </div>
            <div className="meta-card">
              <span className="meta-label">Check-Out Date</span>
              <span className="meta-value">
                {onDetails.booking[0].Depature_DateTime
                  ? onDetails.booking[0].Depature_DateTime.split("T")[0]
                  : "-"}
              </span>
            </div>
            <div className="meta-card">
              <span className="meta-label">Adults Count</span>
              <span className="meta-value">
                {onDetails.booking[0].Num_Of_Adults || "0"}
              </span>
            </div>
            <div className="meta-card">
              <span className="meta-label">Kids Count</span>
              <span className="meta-value">
                {onDetails.booking[0].Num_Of_Kids || "0"}
              </span>
            </div>
            <div className="meta-card highlight">
              <span className="meta-label">Total Guests</span>
              <span className="meta-value">
                {(parseInt(onDetails.booking[0].Num_Of_Adults) || 0) +
                  (parseInt(onDetails.booking[0].Num_Of_Kids) || 0)}
              </span>
            </div>
          </div>

          {/* Table list of guests and documents */}
          <div className="table-wrapper">
            <TableContainer component={Paper} className="table-containor">
              <Table
                sx={{
                  minWidth: 600,
                  backgroundColor: "#ffffff",
                }}
                aria-label="guests document table"
              >
                <TableHead className="table-head">
                  <TableRow>
                    <TableCell className="table-cell">First Name</TableCell>
                    <TableCell className="table-cell">Last Name</TableCell>
                    <TableCell className="table-cell">Gender</TableCell>
                    <TableCell className="table-cell">Date of Birth</TableCell>
                    <TableCell className="table-cell">Contact</TableCell>
                    <TableCell className="table-cell">Document-01</TableCell>
                    {onDetails.files.some((file) =>
                      file.Fieldname?.includes("[documents][2]"),
                    ) && (
                      <TableCell className="table-cell">Document-02</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody className="table-body">
                  {onDetails && (
                    <TableRow className="main-guest-row">
                      <TableCell className="table-cell">
                        {onDetails.Fname}
                      </TableCell>
                      <TableCell className="table-cell">
                        {onDetails.Lname}
                      </TableCell>
                      <TableCell className="table-cell">
                        {onDetails.Gender}
                      </TableCell>
                      <TableCell className="table-cell">
                        {onDetails.DOB ? onDetails.DOB.split("T")[0] : ""}
                      </TableCell>
                      <TableCell className="table-cell">
                        {onDetails.ContactNumber}
                      </TableCell>
                      {onDetails.files
                        .filter((file) =>
                          file.Fieldname.startsWith("guests[0][documents]"),
                        )
                        .map((item) => (
                          <TableCell className="table-cell" key={item.ID}>
                            {item.FileName.endsWith(".pdf") ? (
                              <a
                                href={`${imageBaseURL}${item.FileName}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <div className="pdf-icon-containor">
                                  <PictureAsPdfOutlinedIcon className="pdf-icon" />
                                  <span>View PDF</span>
                                </div>
                              </a>
                            ) : (
                              <a
                                href={`${imageBaseURL}${item.FileName}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={`${imageBaseURL}${item.FileName}`}
                                  alt="Main Guest"
                                />
                              </a>
                            )}
                          </TableCell>
                        ))}
                    </TableRow>
                  )}

                  {onDetails?.childrens && onDetails.childrens.length > 0 ? (
                    onDetails.childrens.map((child, index) => (
                      <TableRow key={child.ID} className="child-guest-row">
                        <TableCell className="table-cell">
                          {child.Fname}
                        </TableCell>
                        <TableCell className="table-cell">
                          {child.Lname}
                        </TableCell>
                        <TableCell className="table-cell">
                          {child.Gender}
                        </TableCell>
                        <TableCell className="table-cell">
                          {child.DOB ? child.DOB.split("T")[0] : ""}
                        </TableCell>
                        <TableCell className="table-cell">--</TableCell>

                        {onDetails.files
                          .filter((file) =>
                            file.Fieldname.startsWith(
                              `guests[${index + 1}][documents]`,
                            ),
                          )
                          .map((item) => (
                            <TableCell className="table-cell" key={item.ID}>
                              {item.FileName.endsWith(".pdf") ? (
                                <a
                                  href={`${imageBaseURL}${item.FileName}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <div className="pdf-icon-containor">
                                    <PictureAsPdfOutlinedIcon className="pdf-icon" />
                                    <span>View PDF</span>
                                  </div>
                                </a>
                              ) : (
                                <a
                                  href={`${imageBaseURL}${item.FileName}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={`${imageBaseURL}${item.FileName}`}
                                    alt="Guest File"
                                  />
                                </a>
                              )}
                            </TableCell>
                          ))}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align="center"
                        className="no-data-cell"
                      >
                        No additional guests registered
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>

        <div className="bottom">
          <button
            type="button"
            onClick={handleCheckin}
            className="confirm-button"
            disabled={loading || onDetails.booking[0].Status === status.confirm}
          >
            {loading
              ? "Confirming..."
              : onDetails.booking[0].Status === status.confirm
                ? "Confirmed"
                : "Confirm Check-In"}
          </button>

          <a href={WA} target="_blank" rel="noopener noreferrer">
            <button className="wa-Btn">
              <div className="wa-sign">
                <svg className="socialSvg whatsappSvg" viewBox="0 0 16 16">
                  <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                </svg>
              </div>
              <div className="wa-text">Whatsapp</div>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ViewDetails;
